import dayjs, { Dayjs } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat'; // Import plugin for localized date formats
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/fr'; // Import French locale
import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup';

dayjs.extend(utc);
dayjs.extend(localizedFormat); // Extend Day.js with the plugin

// Set the locale based on the user's preferences (e.g., from Accept-Language header)
dayjs.locale(navigator?.language ?? 'en'); // Use the user's browser language preference

const printDate = (date: string) => {
  return dayjs(date).format('L');
};

export default printDate;

class DayjsSchema<
  TType extends Maybe<Dayjs> = Dayjs | undefined,
  TContext extends AnyObject = AnyObject,
  TDefault = any,
  TFlags extends yup.Flags = ''
> extends yup.ObjectSchema<TType, TContext, TDefault, TFlags> {
  dayjs(message?: string) {
    return this.test('dayjs', message || 'Invalid Date', function validate(value) {
      if (!value) {
        return true;
      }
      return dayjs.isDayjs(value);
    });
  }
}

const yupDayJs = () => {
  return new DayjsSchema().dayjs();
};

export const translateAsOf = (language: string) => {
  if (language !== 'fr') {
    return 'AS OF ';
  } else {
    return 'À PARTIR DE ';
  }
};

export const translateDateString = (dateString: string, language: string) => {
  const date = dayjs(dateString);

  // If the date is invalid, return the original string with the prefix
  if (!date.isValid() || dateString.length < 7) {
    if (language === 'en') {
      return `AS OF ${dateString}`;
    } else {
      return `À PARTIR DE ${dateString}`;
    }
  }

  if (language === 'en') {
    return `AS OF ${date.locale('en').format('ddd, MMM D, YYYY')}`;
  } else {
    return `À PARTIR DE ${date.locale('fr').format('ddd D MMM YYYY')}`;
  }
};

export { yupDayJs };
